import React from "react";
import classes from "./GoBackHeaderMobile.module.css";

import { Link } from "react-router-dom";

import logo from "../../../images/logoHD.png";
import back from "../../../images/back.png";

const GoBackHeaderMobile = (props) => {
  return (
    <div className={classes.container}>
      <Link to="..">
        <div className={classes.goBack}>
          <img src={back} alt={"back"} />
        
        </div>
      </Link>
      <div className={classes.logo}>
        <Link to="..">
          <img src={logo} alt={"logo"} />
        </Link>
      </div>
      <div className={classes.bigTitle}></div>
    </div>
  );
};
export default GoBackHeaderMobile;
